import { Button } from '@/components/common/button'
import { Card } from '@/components/common/card'
import { Tooltip, TooltipContent } from '@/components/common/tooltip'
import { HelpIcon } from '@/components/icons/help'
import { StrategyReputation } from '@/components/opportunity/opportunityOverview/strategyReputation'
import type { Vault } from '@/types/vault'
import { cn } from '@/utils/cn'

interface Props {
  vault: Vault
  className?: string
}

export const ReputationScore = ({ vault, className }: Props) => {
  return (
    <Card as="section" className={cn('flex flex-col gap-4', className)}>
      <div className="flex items-center justify-between gap-2">
        <h4 className="font-medium text-base text-heading-foreground">Reputation score</h4>
        <Tooltip className="rounded-full">
          <HelpIcon />
          <TooltipContent>
            <div className="flex flex-col gap-2">
              <h6 className="text-xs">How is this score calculated?</h6>
              <p className="max-w-md">
                This score is for informational purposes only. Reputation Score measures how "lindy" this vault and
                protocol are, while also taking into account vault holders and the underlying token. It does not assess
                the security of the underlying network.{' '}
                <Button variant="default" size="default" className="text-accent underline" asChild>
                  <a
                    href="https://docs.vaults.fyi/general/methodology/reputation-score"
                    target="_blank"
                    rel="noreferrer"
                  >
                    How it works
                  </a>
                </Button>
                .
              </p>
            </div>
          </TooltipContent>
        </Tooltip>
      </div>
      <StrategyReputation vault={vault} />
    </Card>
  )
}
